import { Button, Col, Form, InputNumber, Row, Select } from "antd";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addLeaveApplication, getSingleLeaveAllocation, loadSingleLeaveHistory } from "../../redux/rtk/features/leave/leaveSlice";
// import { loadAllLeaveType } from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { loadAllPublicHoliday } from "../../redux/rtk/features/publicHoliday/publicHolidaySlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import getWeeklyOff from "../../utils/getWeeklyOff";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import PublicHolidayDatePicker from "./publicHoliday";
dayjs.extend(isSameOrBefore);

dayjs.extend(utc);
dayjs.extend(timezone);

// Normalize to date-only (YYYY-MM-DD) in local calendar to avoid timezone/00:00 issues
const toDateOnly = (date) =>
  date ? dayjs(date).format("YYYY-MM-DD") : null;

const toPolicyDay = (value) => {
  if (!value) return null;
  const parsed = dayjs(String(value).slice(0, 10));
  return parsed.isValid() ? parsed.startOf("day") : null;
};

const isWithinPolicy = (date, validFrom, validTo) => {
  if (!date) return false;
  const day = dayjs(date).startOf("day");
  const start = toPolicyDay(validFrom);
  const end = toPolicyDay(validTo);
  if (start && day.isBefore(start, "day")) return false;
  if (end && day.isAfter(end, "day")) return false;
  return true;
};

const AddLeave = ({ drawer, onUserChange, validityId, validFrom, validTo }) => {
  const [loader, setLoader] = useState(false);
  const shift = useSelector((state) => state?.shift?.list);
  // const { list, loading } = useSelector((state) => state.leavePolicy);
  const [endDate, setEndDate] = useState(null);
  const [totalDays, setTotalDays] = useState(1);
  // const userId = getUserFromToken();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const userId = getUserFromToken();
  const permissions = getPermissions();
  // console.log("pp", permissions)
  const hasPermission = (item) => {
    return permissions?.includes(item ? item : "");
  };

  const list = useSelector((state) => state?.leave?.leave) || [];
  console.log('list>>', list);
  const loading = useSelector((state) => state.loading || []);
  console.log('loading>>', loading);
  const staffList = useSelector((state) => state?.users?.list);
  const weeklyHoliday = useSelector((state) => state?.weeklyHoliday?.list || []);
  const publicHolidayData = useSelector((state) => state?.publicHoliday?.list || []);
  const leaveHistoryData = useSelector((state) => state?.leaveHistory || []);

  const publicHolidays = Array.isArray(publicHolidayData) ? publicHolidayData : [];
  console.log("publicHolidays", publicHolidays);
  console.log("weeklyHoliday", weeklyHoliday);

  const leaveHistory = Array.isArray(leaveHistoryData) ? leaveHistoryData : [];
  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          dispatch(loadAllPublicHoliday()),
          dispatch(loadAllWeeklyHoliday()),
          dispatch(loadSingleLeaveHistory(userId))
        ]);
      } catch (error) {
        console.error('Error loading calendar data:', error);
      }
    };
    loadData();
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(loadAllStaff({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadAllShift());
    dispatch(getSingleLeaveAllocation(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    form.setFieldsValue({
      leavePolicyId: undefined,
      leaveFrom: null,
      leaveTo: null,
      totalleaveDays: undefined,
    });
    setEndDate(null);
    setTotalDays(1);
  }, [form, validityId]);

  const policyStart = toPolicyDay(validFrom);
  const policyEnd = toPolicyDay(validTo);
  const validityLabel = policyStart && policyEnd
    ? `${policyStart.format("DD/MM/YYYY")} to ${policyEnd.format("DD/MM/YYYY")}`
    : "";

  // useEffect(() => {
  //   dispatch(loadAllShift());
  //   // dispatch(loadAllLeaveType());
  // }, [dispatch]);

  // Check if a date is a working day (excludes public holiday and weekly off for the user)
  const isWorkingDay = (dateStr, effectiveUserId) => {
    const publicHolidayDates = new Set(
      publicHolidays.map((h) => dayjs(h.date).format("YYYY-MM-DD"))
    );
    if (publicHolidayDates.has(dateStr)) return false;
    if (weeklyHoliday?.length) {
      return getWeeklyOff(dateStr, weeklyHoliday, effectiveUserId);
    }
    const day = dayjs(dateStr).day();
    return day !== 0 && day !== 6;
  };

  // Calculate end date from start date and number of working days (excludes public & weekly holidays)
  const calculateEndDateFromWorkingDays = (startDate, workingDays, effectiveUserId) => {
    const startStr = toDateOnly(startDate);
    if (!startStr || !workingDays || workingDays <= 0) return null;
    let count = 0;
    let current = dayjs(startStr);
    const daysToCount = Math.max(1, Math.ceil(workingDays));
    while (count < daysToCount) {
      if (policyEnd && current.isAfter(policyEnd, "day")) return null;
      const dateStr = current.format("YYYY-MM-DD");
      if (isWorkingDay(dateStr, effectiveUserId)) count++;
      if (count >= daysToCount) break;
      current = current.add(1, "day");
    }
    if (policyEnd && current.isAfter(policyEnd, "day")) return null;
    return current;
  };

  const calculateEndDate = (startDate, days) => {
    if (!(startDate && days != null)) return true;
    const effectiveUserId = form.getFieldValue("userId") || userId;
    const newEndDate =
      days <= 1
        ? dayjs(startDate)
        : calculateEndDateFromWorkingDays(startDate, days, effectiveUserId);
    if (!newEndDate || (policyEnd && !isWithinPolicy(newEndDate, validFrom, validTo))) {
      toast.warning("The leave period must stay inside the selected leave policy validity.");
      return false;
    }
    setEndDate(newEndDate);
    form.setFieldsValue({ leaveTo: newEndDate });
    return true;
  };

  const handleTotalDaysChange = (value) => {
    const startDate = form.getFieldValue("leaveFrom");
    if (startDate && !calculateEndDate(startDate, value)) {
      form.setFieldsValue({ totalleaveDays: totalDays });
      return;
    }
    setTotalDays(value);
  };

  // const handleStartDateChange = (date) => {
  //   calculateEndDate(date, totalDays);
  // };


  // Send date-only to avoid timezone issues (no 00:00 so server doesn't shift day)
  const formatDate = (date) => {
    return toDateOnly(date);
  };

  const handleUserSelection = (userId) => {
    if (onUserChange) {
      onUserChange(userId);
    }
  };

  const calculateLeaveDays = (startDate, endDate, effectiveUserId) => {
    const startStr = toDateOnly(startDate);
    const endStr = toDateOnly(endDate);
    if (!startStr || !endStr) return 0;
    let totalDays = 0;
    let current = dayjs(startStr);
    const end = dayjs(endStr);
    while (current.isSame(end, "day") || current.isBefore(end, "day")) {
      const dateStr = current.format("YYYY-MM-DD");
      if (isWorkingDay(dateStr, effectiveUserId)) totalDays++;
      current = current.add(1, "day");
    }
    return totalDays;
  };



  const handleStartDateChange = (date) => {
    if (date && !isWithinPolicy(date, validFrom, validTo)) {
      form.setFieldsValue({ leaveFrom: null });
      toast.warning("Start date must fall within the selected leave policy validity period.");
      return;
    }
    const endDate = form.getFieldValue("leaveTo");
    const effectiveUserId = form.getFieldValue("userId") || userId;
    const leaveDays = calculateLeaveDays(date, endDate, effectiveUserId);
    setTotalDays(leaveDays);
    form.setFieldsValue({ totalleaveDays: leaveDays });
    setEndDate(endDate);
  };

  const handleEndDateChange = (date) => {
    if (date && !isWithinPolicy(date, validFrom, validTo)) {
      form.setFieldsValue({ leaveTo: null });
      setEndDate(null);
      toast.warning("End date must fall within the selected leave policy validity period.");
      return;
    }
    const startDate = form.getFieldValue("leaveFrom");
    const effectiveUserId = form.getFieldValue("userId") || userId;
    const leaveDays = calculateLeaveDays(startDate, date, effectiveUserId);
    setTotalDays(leaveDays);
    form.setFieldsValue({ totalleaveDays: leaveDays });
    setEndDate(date);
  };



  const onFinish = async (values) => {
    try {
      if (!isWithinPolicy(values.leaveFrom, validFrom, validTo) || !isWithinPolicy(values.leaveTo, validFrom, validTo)) {
        toast.error(
          validityLabel
            ? `Leave dates must fall within the selected leave policy validity period (${validityLabel}).`
            : "Leave dates must fall within the selected leave policy validity period."
        );
        return;
      }

      setLoader(true);
      const leaveData = {
        ...values,
        userId: hasPermission("update-role") ? values.userId : userId,
        leaveFrom: formatDate(values.leaveFrom),
        leaveTo: formatDate(values.leaveTo),
        totalleaveDays: values.totalleaveDays
      };

      const resp = await dispatch(addLeaveApplication(leaveData));

      if (resp.payload.message === "success") {
        // toast.success("Leave application submitted successfully");
        form.resetFields();
        setEndDate(null);
        setTotalDays(1);
        dispatch(loadAllShift());
      } else {
        // toast.error("Failed to submit leave application");
      }
    } catch (error) {
      toast.error("An error occurred while submitting leave application");
    } finally {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Please fill all required fields");
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-leaveApplication"}>
        <Row className='mr-top' justify={drawer ? "center" : "center"}>
          <Col className=''>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name='leave-form'
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >

              {hasPermission("update-role") && (
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label='Employee'
                  name='userId'
                  rules={[
                    {
                      required: true,
                      message: "Please select an employee!",
                    },
                  ]}>
                  <Select placeholder='Select Employee'
                    showSearch
                    allowClear
                    onChange={handleUserSelection}
                    filterOption={(input, option) =>
                      String(option.children).toLowerCase().includes(input.toLowerCase())
                    }>
                    {staffList?.slice() // Create a copy to avoid mutating the original array
											.sort((a, b) => a.firstName.localeCompare(b.firstName)).map((staff) => (
                      <Select.Option key={staff.id} value={staff.id}>
                        {staff.firstName} {staff.lastName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Leave Type"
                name="leavePolicyId"
                rules={[{ required: true, message: "Please select a leave type!" }]}
              >
                <Select
                  mode="single"
                  placeholder="Select leave type"
                  showSearch allowClear
                  filterOption={(input, option) =>
                    String(option.children).toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {list.length > 0 ? (
                    list
                      .filter((leave) => {
                        // Filter by validity_id if provided
                        if (validityId) {
                          return leave?.leavePolicy?.validity_id === validityId;
                        }
                        return true; // Show all if no validity_id filter
                      })
                      .map((leave) => (
                        <Select.Option key={leave?.leavePolicy?.id} value={leave?.leavePolicy?.id}>
                          {leave?.leavePolicy?.name}
                        </Select.Option>
                      ))
                  ) : (
                    <Select.Option disabled>No leave types available</Select.Option>
                  )}
                </Select>
              </Form.Item>


              {/* <Form.Item
                style={{ marginBottom: "10px" }}
                label='Start Date'
                name='leaveFrom'
                rules={[{ required: true, message: "Please select start date!" }]}
              >
                <DatePicker
                  onChange={handleStartDateChange}
                  format="YYYY-MM-DD"
                  showTime={false}
                />
              </Form.Item> */}
              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Start Date'
                name='leaveFrom'
                rules={[
                  { required: true, message: "Please select start date!" },
                  {
                    validator: (_, value) => {
                      if (!value || isWithinPolicy(value, validFrom, validTo)) return Promise.resolve();
                      return Promise.reject(new Error("Date is outside the selected leave policy validity period"));
                    },
                  },
                ]}
              >
                <PublicHolidayDatePicker
                  publicHolidays={publicHolidays}
                  validFrom={validFrom}
                  validTo={validTo}
                  disabled={!policyStart || !policyEnd}
                  inputReadOnly
                  onChange={(date, holiday) => {
                    handleStartDateChange(date);
                    if (holiday) {
                      console.log(`Selected date is a holiday: ${holiday.name}`);
                    }
                  }}
                  format="YYYY-MM-DD"
                  showTime={false}
                  showToday={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "20px" }}
                label="End Date"
                name="leaveTo"
                rules={[
                  { required: true, message: "Please select End date!" },
                  {
                    validator: (_, value) => {
                      if (!value || isWithinPolicy(value, validFrom, validTo)) return Promise.resolve();
                      return Promise.reject(new Error("Date is outside the selected leave policy validity period"));
                    },
                  },
                ]}

              >

                <PublicHolidayDatePicker
                  publicHolidays={publicHolidays}
                  validFrom={validFrom}
                  validTo={validTo}
                  disabled={!policyStart || !policyEnd}
                  inputReadOnly
                  value={endDate}
                  onChange={handleEndDateChange}
                  format="YYYY-MM-DD"
                  showTime={false}
                  showToday={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label='Total Days'
                name='totalleaveDays'
                rules={[{ required: true, message: "Please enter the total days!" }]}
              >
                <InputNumber
                  min={0.25}
                  step={0.25}
                  onChange={handleTotalDaysChange}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ offset: 6, span: 12 }}
              >
                <Button
                  type='primary'
                  size='large'
                  htmlType='submit'
                  block
                  loading={loader}
                  disabled={loader}
                >
                  {loader ? 'Submitting...' : 'Submit Leave'}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
    </Fragment>
  );
};

export default AddLeave;